import React from 'react';
import styled from 'styled-components';
import { SkeletonBlock } from './generic-skeleton-placeholders';

const NUM_CHARTS = 16;
const KPI_CARD_PLUS_NEXT = 2;
const REMAINING_CARDS = NUM_CHARTS - KPI_CARD_PLUS_NEXT;

const DashboardSkeletonGridWrapper = styled.div`
  margin-top: 75px;
  display: grid;
  grid-template-columns: repeat(auto-fill, 405px);
  grid-template-rows: repeat(auto-fill, 405px);
  grid-column-gap: 15px;
  grid-row-gap: 15px;
  padding-left: 38px;
  padding-right: 38px;

  .left-of-kpi {
    grid-column: 3 / 4;
  }

  .rs-placeholder-graph {
    border-radius: 10px;
  }
`;

const KpiChartSkeleton = () => (
  <SkeletonBlock height={405} width={825} margin="unset" />
);

const ChartCardSkeleton = () => (
  <SkeletonBlock height={405} width={405} margin="unset" />
);

export function DashboardSkeleton() {
  return (
    <DashboardSkeletonGridWrapper>
      <KpiChartSkeleton />
      <div className="left-of-kpi">
        <ChartCardSkeleton />
      </div>
      {Array(REMAINING_CARDS)
        .fill(ChartCardSkeleton)
        .map((CardSkeleton, idx) => (
          <CardSkeleton key={idx} />
        ))}
    </DashboardSkeletonGridWrapper>
  );
}
